<template>
    <div id="sweetCalendar">
        <div class="container calendar">
            <div class="header">
                <div class="left-arrow" @click="prevMonth">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M10.4142 12L15.7071 17.2929C16.0976 17.6834 16.0976 18.3166 15.7071 18.7071C15.3166 19.0976 14.6834 19.0976 14.2929 18.7071L8.29289 12.7071C7.90237 12.3166 7.90237 11.6834 8.29289 11.2929L14.2929 5.29289C14.6834 4.90237 15.3166 4.90237 15.7071 5.29289C16.0976 5.68342 16.0976 6.31658 15.7071 6.70711L10.4142 12Z"
                            fill="#0B1022" fill-opacity="0.3"/>
                    </svg>
                </div>
                <div class="month">{{ selectedMonthName }} {{ selectedYear }}</div>
                <div class="right-arrow" @click="nextMonth" >
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M8.29289 17.2929C7.90237 17.6834 7.90237 18.3166 8.29289 18.7071C8.68342 19.0976 9.31658 19.0976 9.70711 18.7071L15.7071 12.7071C16.0976 12.3166 16.0976 11.6834 15.7071 11.2929L9.70711 5.29289C9.31658 4.90237 8.68342 4.90237 8.29289 5.29289C7.90237 5.68342 7.90237 6.31658 8.29289 6.70711L13.5858 12L8.29289 17.2929Z"
                            fill="#0B1022" fill-opacity="0.3"/>
                    </svg>
                </div>
            </div>
            <div class="weekdays-container">
                <div
                    v-for="(day, index) in weekdays"
                    :key="`day-name-${index + 1}`"
                    class="day-name first_letter_uppercase"
                    :title="day"
                >
                {{ day[0] }}{{ day[1] }}
                </div>
            </div>
            <div class="body">
                <div v-for="(day,index) in days" :key="index" class="day-container">
                    <div class="before" v-if="day" :style="generateBeforeStyle(day)">&nbsp;</div>
                    <div
                        v-if="day"
                        :class="[
                        'day',
                        `day-${day.getDate()},
                        weekday-${day.getDay()}`,
                        offDays.includes(day.getDay()) ? 'off-day' : null,
                        day.toDateString() === today.toDateString() ? 'today' : null,
                        day.toDateString() === selectedDate ? 'day-selected' : null
                        ]"
                        :style="generateDayStyle(day)"
                        @click="selectDay(day)"
                    >
                        <span>{{ day.getDate() }}</span>
                    </div>
                    <div class="after" v-if="day" :style="generateAfterStyle(day)">&nbsp;</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import DateTime from './DateTime.js'

    export default {
        name: 'Calendar',
        data() {
            return {
                today: new DateTime(),
                selectedDate: '',
                date: null,
                weekdays: null
            }
        },
        computed: {
            days() {
                let emptyDays = Array((this.startWeekDayOfMonth - this.firstDayOfWeek + 7) % 7).fill(null)
                let days = Array(this.numberOfDays).fill().map((item, index) => new DateTime(this.selectedYear, this.selectedMonth, index + 1))
                return emptyDays.concat(days)
            },
            startWeekDayOfMonth() {
                return this.date.getFirstWeekdayOfMonth()
            },
            numberOfDays() {
                return this.date.getNumberOfDaysInMonth()
            },
            selectedMonth() {
                return this.date.getMonth()
            },
            selectedMonthName() {
                return this.monthNames[this.date.getMonth() - 1]
            },
            selectedYear() {
                return this.date.getFullYear()
            }
        },
        watch: {
            weekdaysNames: function (val) {
                this.weekdays = this.generateWeekdayNames(this.firstDayOfWeek)
            },
        },
        methods: {
            prevMonth() {
                this.date = new DateTime(this.selectedYear, this.selectedMonth - 1, 1);
                this.$emit('prevMonthEvent', {year: this.selectedYear, month: this.selectedMonth});
            },
            nextMonth() {
                this.date = new DateTime(this.selectedYear, this.selectedMonth + 1, 1);
                this.$emit('nextMonthEvent', {year: this.selectedYear, month: this.selectedMonth});
            },
            selectDay(day) {
                this.selectedDate = day.toDateString();
                this.$emit('selectedDateEvent', {year: this.selectedYear, month: this.selectedMonth, day: day.getDate()});
            },
            generateWeekdayNames(firstDayOfWeek = 1) {
                let weekdays = [];
                for (let i = 0; i < this.weekdaysNames.length; i++) {
                weekdays.push(this.weekdaysNames[i]);
                }
                for (let i = 2; i <= firstDayOfWeek; i++) {
                let first = weekdays.shift();
                weekdays.push(first)
                }
                return weekdays
            },
            generateDayStyle(date) {
                let style = {}
                for (let event of this.events) {
                if (date.isInRange(event.start, event.end, event.repeat)) {
                    let category = this.eventCategories.find(item => item.id === event.categoryId) || {}
                    Object.assign(style, {
                    color: category.id ? category.textColor : null,
                    backgroundColor: category.id ? category.backgroundColor : null,
                    // fontWeight: category.id ? 'bold' : 'normal'
                    })
                }
                }
                return style
            },
            generateBeforeStyle(date) {
                let style = {}
                for (let event of this.events) {
                if (date.isInRange(event.start, event.end, event.repeat) && date.getPrevDay().isInRange(event.start, event.end, event.repeat)) {
                    let category = this.eventCategories.find(item => item.id === event.categoryId) || {}
                    Object.assign(style, {
                    backgroundColor: category.backgroundColor
                    })
                }
                }
                return style
            },
            generateAfterStyle(date) {
                let style = {}
                for (let event of this.events) {
                if (date.isInRange(event.start, event.end, event.repeat) && date.getNextDay().isInRange(event.start, event.end, event.repeat)) {
                    let category = this.eventCategories.find(item => item.id === event.categoryId) || {}
                    Object.assign(style, {
                    backgroundColor: category.backgroundColor
                    })
                }
                }
                return style
            },
            goToday() {
                this.date = this.today
            }
        },
        props: {
            initialDate: {
                type: String,
                default: null
            },
            firstDayOfWeek: {
                type: Number,
                default: 1 // 1: Sunday, 2: Monday, etc
            },
            weekdaysNames: {
                type: Array,
                default() {
                    return [
                        'sunday',
                        'monday',
                        'tuesday',
                        'wednesday',
                        'thursday',
                        'friday',
                        'saturday'
                    ]
                }
            },
            monthNames: {
                type: Array,
                default() {
                    return [
                        'january',
                        'february',
                        'march',
                        'april',
                        'may',
                        'june',
                        'july',
                        'august',
                        'september',
                        'october',
                        'november',
                        'december'
                    ]
                }
            },
            eventCategories: {
                type: Array,
                default() {
                    return []
                }
            },
            events: {
                type: Array,
                default() {
                    return []
                }
            },
            offDays: {
                type: Array,
                default() {
                    return []
                }
            }
        },
        beforeMount() {
            this.date = Date.parse(this.initialDate) ? new DateTime(this.initialDate) : new DateTime()
            this.weekdays = this.generateWeekdayNames(this.firstDayOfWeek)
        }
    }
</script>

<style lang="sass" scoped>
  @import './index.sass'
  .first_letter_uppercase:first-letter
    text-transform: uppercase
</style>